module.exports = __webpack_public_path__ + "static/media/W18-1222_AW_350_Teen_Mobile_Hero_767x845_fr.b9d0be7d.jpg";